import { RouteRecordRaw } from 'vue-router'
import XpressProfile from '@/views/xpress/profile/XpressProfile.vue'
import XpressLayout from '@/views/xpress/XpressLayout.vue'

const xpressRoutes: RouteRecordRaw[] = [
  {
    path: '/xpress',
    component: XpressLayout,
    children: [
      {
        path: '',
        redirect: { name: 'XpressProfile' },
      },
      {
        path: 'profile',
        children: [
          {
            path: '',
            name: 'XpressProfile',
            component: XpressProfile,
            meta: { title: 'My Profile', showBackButton: false, headerMode: 'icon' },
          },
          {
            path: 'settings',
            name: 'XpressProfileSettings',
            component: () => import('@/views/xpress/profile/XpressProfileSettings.vue'),
            meta: { title: 'ข้อมูลสมาชิก', showBackButton: true, headerMode: 'title' },
          },
          {
            path: 'accum',
            name: 'XpressProfileAccum',
            component: () => import('@/views/xpress/accum/XpressProfileAccum.vue'),
            meta: { title: 'ประวัติคะแนนสะสมทั้งหมด', showBackButton: true, headerMode: 'title' },
          },
          {
            path: 'voucher',
            name: 'XpressProfileVoucher',
            component: () => import('@/views/xpress/voucher/XpressProfileVoucher.vue'),
            meta: { title: 'บัตรกำนัล', showBackButton: true, headerMode: 'title' },
          },
          {
            path: 'course',
            name: 'XpressProfileCourse',
            component: () => import('@/views/xpress/course/XpressProfileCourse.vue'),
            meta: { title: 'คอร์สของฉัน', showBackButton: true, headerMode: 'title' },
          },
        ],
      },
      {
        path: 'redeem',
        children: [
          {
            path: '',
            name: 'XpressRedeem',
            component: () => import('@/views/xpress/redeem/XpressRedeem.vue'),
            meta: { title: 'แลกของรางวัล', showBackButton: false, headerMode: 'icon' },
          },
          {
            path: ':uuid',
            name: 'XpressRedeemDetail',
            component: () => import('@/views/xpress/redeem/XpressRedeemDetail.vue'),
            meta: { title: 'รายละเอียดสิทธิพิเศษ', showBackButton: true, headerMode: 'icon' },
          },
        ],
      },
      {
        path: 'appointment',
        name: 'XpressAppointment',
        component: () => import('@/views/xpress/appointment/XpressAppointment.vue'),
        meta: { title: 'นัดหมาย', showBackButton: false, showHeader: false },
      },
    ],
  },
]

export default xpressRoutes
